import React from 'react';
import { createHashHistory } from 'history';
import { applyMiddleware, createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import SigninPage from './SigninPage';
import { createAuthMiddleware } from './auth/middleware';
import MeetingPage from './MeetingPage';
import { createRootReducer } from './RootReducer';
import { createMeetingMiddleware } from './meeting-creator/middleware';
import CopyMeetingPage from './CopyMeetingPage';
import CreateLandingPage from './CreateLandingPage';
import ErrorPage from './ErrorPage';
import moment from 'moment';
import 'moment/min/locales.min';
import { initializeIcons } from 'office-ui-fabric-react';
import { getUserLocale } from './localization/translate';
import { parameters } from './util/parameters';
import queryString from 'query-string';
moment.locale(getUserLocale());
initializeIcons();
const hist = createHashHistory();
const store = createStore(createRootReducer(hist), compose(applyMiddleware(routerMiddleware(hist), createAuthMiddleware(), createMeetingMiddleware())));
function App() {
    const queryParams = queryString.parse(location.search);
    const nonce = queryParams === null || queryParams === void 0 ? void 0 : queryParams.nonce;
    let params = parameters.getInstance();
    params.setNonce(nonce);
    const returnUrl = decodeURIComponent(queryParams === null || queryParams === void 0 ? void 0 : queryParams.returnurl);
    params.setReturnUrl(returnUrl);
    return (React.createElement(Provider, { store: store },
        React.createElement(ConnectedRouter, { history: hist },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/signin", component: SigninPage }),
                React.createElement(Route, { exact: true, path: "/createMeeting", component: MeetingPage }),
                React.createElement(Route, { exact: true, path: "/copyMeeting", component: CopyMeetingPage }),
                React.createElement(Route, { exact: true, path: "/error", component: ErrorPage }),
                React.createElement(Route, { component: CreateLandingPage })))));
}
export default App;
